// 사건이 왜 나왔는지 한 줄로 설명한다. 기록과 데이터에서만 만들고, 만들 수 없으면 null 이다.
// - 서사 축 사건: 현재 막의 주제(서사 축 데이터의 theme, 근거 카드는 draft)
// - 손실·전환 조건 사건: 대운 영역과 승인된 전환 라벨(전환 유형 분류는 게임 규칙)
import { directionFor } from './arcDirection.js';
import { GROUP_LABEL } from './rules.js';
import { LUCK_TRANSITIONS } from './luckTransitions.js';

/** ctx: { essence, age, luck(luckAt 결과), type(전환 유형 또는 null) } → { text, cardIds, tier } | null */
export function eventWhy(ctx, event) {
  const rule = event?.rules;
  if (!rule || !ctx?.essence) return null;
  if (rule.arc?.length) {
    const direction = directionFor(ctx.essence, ctx.age);
    if (direction?.theme) return { text: `이 시기의 주제: ${direction.theme}`, cardIds: [...direction.cardIds], tier: 'classic' };
  }
  if (rule.transition?.length) {
    const label = ctx.type ? LUCK_TRANSITIONS.labels?.[ctx.type] : null;
    if (label && ctx.luck?.group) return { text: `${GROUP_LABEL[ctx.luck.group]} 쪽 대운이 들어와 ${label}예요.`, cardIds: [...LUCK_TRANSITIONS.cardIds], tier: 'game' };
  }
  return null;
}
